<template>
  <b-container>
    <b-row class="justify-content-center">
      <b-col cols="6" class="text-center">
        <h2>Upload Offers (CSV) file</h2>
        <hr />
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col cols="4" class="text-center">
        <div v-if="isInitial || isSaving" class="drop-area">
          <input type="file" ref="file" class="input-file" @change="handleFileUpload()" />
          <p v-if="isInitial">
            Drag your file here to begin<br />
            or click to browse
          </p>
          <p v-if="isSaving">Uploading file... <b-spinner/></p>
        </div>
        <div v-if="isSuccess">
          <strong>Upload succesful.</strong>
          <b-button variant="warning" class="btn-offer-upload-reset" @click="reset()">
            Reset
          </b-button>
        </div>
        <!-- FAILED -->
        <div v-if="isFailed">
          <strong>Uploaded failed.</strong>
          <pre>{{ uploadError }}</pre>
          <b-button variant="warning" class="btn-offer-upload-reset" @click="reset()">
            Reset
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col cols="8">
        <offer-upload-history @clearHistory="onClearHistory" :upload-history="uploadHistory"></offer-upload-history>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import store from 'src/store';
import constants from 'src/constants/constants';
import OfferUploadHistory from 'Components/offer/OfferUploadHistory';

const STATUS_INITIAL = 10;
const STATUS_SAVING = 11;
const STATUS_SUCCESS = 12;
const STATUS_FAILED = 13;

export default {
  name: 'OfferUpload',
  components: {
    OfferUploadHistory,
  },
  data: function() {
    return {
      file: '',
      currentStatus: null,
      uploadError: null,
      historyListLocalStorageName: 'history_list',
      uploadHistory: [],
    };
  },
  methods: {
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.submitOfferUpload();
    },
    submitOfferUpload() {
      this.currentStatus = STATUS_SAVING;
      store
        .dispatch('uploadCsvFile', {
          file: this.file,
          url: constants.url.offerService.baseUrl + constants.url.offerService.api.offersUpload,
        })
        .then((response) => {
          this.currentStatus = STATUS_SUCCESS;
          this.addToHistoryItems(response.data.results);
          console.log('(offer-service) upload worked!');
        })
        .catch(() => {
          this.currentStatus = STATUS_FAILED;
          console.log('(offer-service) upload didn’t work');
        });
    },
    addToHistoryItems: function(item) {
      let historyList = JSON.parse(this.getHistoryList());
      let historyItem = {
        meta_data: item.meta_data,
        errors: item.errors,
      };

      historyList.historyItems.unshift(historyItem);
      localStorage.setItem(this.historyListLocalStorageName, JSON.stringify(historyList));
      this.displayHistoryList(historyList);
    },

    getHistoryList: function() {
      let historyListJson = localStorage.getItem(this.historyListLocalStorageName);
      if (historyListJson === null) {
        localStorage.setItem(this.historyListLocalStorageName, JSON.stringify({ historyItems: [] }));
      }
      return localStorage.getItem(this.historyListLocalStorageName);
    },
    displayHistoryList: function() {
      this.uploadHistory = JSON.parse(this.getHistoryList());
    },
    clearHistory: function() {
      localStorage.removeItem(this.historyListLocalStorageName);
      this.displayHistoryList();
    },
    onClearHistory: function() {
      this.clearHistory();
    },
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  mounted() {
    this.reset();
    this.displayHistoryList();
  },
};
</script>

<style lang="scss">
.btn-offer-upload-reset {
  margin-left: 20px;
}

.drop-area {
  border: 2px dashed #999999;
  background: #efefff;
  color: #666666;
  min-height: 200px;
  cursor: pointer;

  &:hover {
    background: #dedefa;
  }

  p {
    text-align: center;
    color: #555555;
    padding: 50px 0;
  }
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 200px;
  cursor: pointer;
  position: absolute;
  left: 0;
}
</style>
